<template>
  <div
    class="flex h-full flex-col justify-between"
    data-qa="out-of-stock-product-select"
  >
    <div class="flex flex-col">
      <h3 class="body-1-bold mb-16">
        {{ i18n(translations.title) }}
      </h3>
      <p class="body-2 mb-24">
        {{ i18n(translations.subtitle) }}
      </p>

      <div class="flex flex-col gap-16">
        <div
          v-for="orderLine in orderLines"
          :key="orderLine.id"
          class="bg-static-default-low rounded-lg flex p-16"
        >
          <RevCheckbox
            :id="'orderline-' + orderLine.id"
            v-model="selectedOrderLines"
            class="w-full"
            :value="orderLine.id.toString()"
          >
            <template #label>
              <div class="flex w-full flex-col">
                <div class="body-1-bold mb-12">
                  {{ orderLine.productName }}
                </div>

                <div class="mb-8 flex w-full items-center justify-between">
                  <span class="body-2">{{ i18n(translations.sku) }}: </span>
                  <span class="break-all text-right">{{ orderLine.sku }}</span>
                </div>

                <div class="flex w-full items-center justify-between">
                  <span class="body-2 flex-1">
                    {{ i18n(translations.appearance) }}:
                  </span>
                  <RevTag :label="orderLine.grade.label" variant="secondary" />
                </div>
              </div>
            </template>
          </RevCheckbox>
        </div>
      </div>
    </div>

    <RevButton
      data-qa="continue-button"
      :disabled="!selectedOrderLines.length"
      full-width="always"
      variant="primary"
      @click="handleContinue"
    >
      {{ i18n(translations.continue) }}
    </RevButton>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { GetSellerXpOrderDetails } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants-orders/merchant-orders-pages.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCheckbox } from '@ds/components/Checkbox'
import { RevTag } from '@ds/components/Tag'

import translations from './OrderLineSelect.translations'

defineProps<{
  orderLines: GetSellerXpOrderDetails['orderLines']
}>()

const emit = defineEmits<{
  (e: 'continue', orderLineIds: string[]): void
}>()

const i18n = useI18n()
const selectedOrderLines = ref<string[]>([])

function handleContinue() {
  emit('continue', selectedOrderLines.value)
}
</script>
